import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  HourglassEmpty as HourglassEmptyIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { useClinicTheme } from "../../theme";
import colors from "../../styles/colors";

const VARIANT_DEFS = {
  load: { text: "Yükleniyor", Icon: HourglassEmptyIcon, colorKey: "primary" },
  save: { text: "Kaydediliyor", Icon: SaveIcon, colorKey: "success" },
  delete: { text: "Siliniyor", Icon: DeleteIcon, colorKey: "error" },
  create: { text: "Oluşturuluyor", Icon: AddIcon, colorKey: "primary" },
};

export default function ActionLoadingOverlay({
  show,
  variant = "load",
  fixed = false,
  text: customText,
  children,
  sx = {},
}) {
  const { palette } = useClinicTheme();
  if (!show) return null;

  const config = VARIANT_DEFS[variant] || VARIANT_DEFS.load;
  const text = customText ?? config.text;
  const Icon = config.Icon;
  const color = config.colorKey === "primary" ? palette.primary
    : config.colorKey === "success" ? (palette.success || colors.success)
    : config.colorKey === "error" ? (palette.error || colors.error)
    : palette.primary;

  const baseSx = {
    bgcolor: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(6px)",
    zIndex: fixed ? 1400 : 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2,
    borderRadius: 3,
    ...sx,
  };

  return (
    <Box
      sx={
        fixed
          ? {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              ...baseSx,
            }
          : {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              ...baseSx,
            }
      }
    >
      <CircularProgress size={44} sx={{ color }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Icon sx={{ fontSize: 28, color }} />
        <Typography sx={{ fontWeight: 900, fontSize: "1.1rem", color }}>
          {text}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
